import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

// Light partner band — official brand logos on a white background (per each brand's visual guidelines).
const partners = [
  { name: "Zoho", src: "/zoho-logo-web.svg", cls: "max-h-12" },
  { name: "Adobe Registered Reseller", src: "/adobe-reseller-badge.webp", cls: "max-h-16" },
  { name: "Razorpay", src: "/razorpay-logo.webp", cls: "max-h-8" },
  { name: "Absolute", src: "/absolute-logo.webp", cls: "max-h-9" },
  { name: "Hostinger Partner", src: "/hostinger-partner-badge.webp", cls: "max-h-16", to: "/hostinger-offer" },
];

export default function PartnerMarquee() {
  return (
    <section data-testid="partner-marquee" className="partner-band py-16 overflow-hidden border-y border-slate-200">
      <div className="max-w-8xl mx-auto px-6 mb-10">
        <div className="label text-xs text-cobalt text-center">Official Partner &amp; Reseller</div>
      </div>
      <Marquee speed={38} gradient gradientColor="#ffffff" gradientWidth={140} pauseOnHover>
        {partners.map((p, i) => {
          const img = <img src={p.src} alt={`${p.name} logo`} className={`${p.cls || "max-h-14"} w-auto object-contain`} />;
          const cls = "mx-12 flex items-center justify-center h-16";
          const tid = `partner-logo-${p.name.toLowerCase().replace(/\s+/g, "-")}`;
          return p.to ? (
            <Link key={i} to={p.to} data-testid={tid} className={`${cls} hover:scale-105 transition-transform`} title={`${p.name} — exclusive 20% off offer`}>{img}</Link>
          ) : (
            <div key={i} data-testid={tid} className={cls}>{img}</div>
          );
        })}
      </Marquee>
    </section>
  );
}
